import {
  IBillingContract,
  IBillingContractData,
  IBillingContracts,
  IBillingContractsData,
  IGatewayInvoiceDetails,
  IGatewayInvoiceDetailsData,
  IGatewayInvoices,
  IGatewayInvoicesData,
  ITrxCountFee,
  ITrxFee,
} from './types';

export const normalizeBillingContracts = (
  data: IBillingContractsData,
): IBillingContracts => {
  return {
    beginDate: (data?.beginDate as string) || '',
    contractDate: (data?.contractDate as string) || '',
    contractNumber: (data?.contractNumber as string) || '',
    contractType: (data?.contractType as string) || '',
    description: (data?.description as string) || '',
    disabledAfterDay: (data?.disabledAfterDay as number) || null,
    endDate: (data?.endDate as string) || '',
    hqLegalEntity: {
      id: (data?.hqLegalEntity?.id as number) || 0,
      name: (data?.hqLegalEntity?.name as string) || '',
    },
    id: (data?.id as number) || 0,
    includeDisabled: !!data?.includeDisabled,
    merchant: {
      enabled: !!data?.merchant?.enabled,
      id: (data?.merchant?.id as number) || 0,
      name: (data?.merchant?.name as string) || '',
    },
    minTurnover: (data?.minTurnover as number) || null,
    minTurnoverFee: (data?.minTurnoverFee as number) || null,
    minTurnoverFeeMode: (data?.minTurnoverFeeMode as string) || '',
    overdueFee: (data?.overdueFee as number) || null,
    splitTrxCountFee: !!data?.splitTrxCountFee,
    splitTrxFee: !!data?.splitTrxFee,
    version: (data?.version as number) || 0,
  };
};

export const normalizeBillingContract = (
  data: IBillingContractData,
): IBillingContract => {
  return {
    ...normalizeBillingContracts(data),
    trxCountFee: (data?.trxCountFee as ITrxCountFee[]) || [],
    trxFee: (data?.trxFee as ITrxFee[]) || [],
  };
};

export const normalizeGatewayInvoice = (data: IGatewayInvoicesData): IGatewayInvoices => {
  return {
    beginDate: (data.beginDate as string) || '',
    billingContract: { ...normalizeBillingContract(data?.billingContract) },
    byMerchantTerminal: !!data?.byMerchantTerminal,
    created: (data.created as string) || null,
    endDate: (data.endDate as string) || '',
    id: (data.id as number) || 0,
    integrationFee: (data.integrationFee as number) || null,
    integrationFeeValue: (data.integrationFeeValue as number) || null,
    integrationList: (data.integrationList as string[]) || [],
    invoiceDate: (data.invoiceDate as string) || '',
    minTurnoverFee: (data.minTurnoverFee as number) || 0,
    status: (data.status as string) || '',
    totalFeeWOIntegration: (data.totalFeeWOIntegration as number) || 0,
    totalFeeWOVat: (data.totalFeeWOVat as number) || 0,
    trxCount: (data.trxCount as number) || 0,
    trxCountFee: (data.trxCountFee as number) || 0,
    trxVolume: (data.trxVolume as number) || 0,
    trxVolumeFee: (data.trxVolumeFee as number) || 0,
  };
};

export const normalizeGatewayInvoiceDetails = (
  data: IGatewayInvoiceDetailsData,
): IGatewayInvoiceDetails => {
  return {
    id: (data.id as number) || 0,
    merchantTerminal: {
      id: (data.merchantTerminal.id as number) || 0,
      name: (data.merchantTerminal.name as string) || '',
    },
    merchantTerminalEnabled: !!data.merchantTerminalEnabled,
    minTurnoverFee: (data.minTurnoverFee as number) || 0,
    totalFeeWOVat: (data.totalFeeWOVat as number) || 0,
    trxCount: (data.trxCount as number) || 0,
    trxCountFee: (data.trxCountFee as number) || 0,
    trxVolume: (data.trxVolume as number) || 0,
    trxVolumeFee: (data.trxVolumeFee as number) || 0,
  };
};
